var _defs, _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg13(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 97 97",
    width: 97,
    height: 97,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-150-2209h1366v3181h-1366z"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:#004cbd}.b{fill:#f29988}.c{fill:#ea806f}.d{fill:#2a92fa}.e{fill:#4eb1fc}.f{fill:#f0f0ff}.g{fill:#ffcec0}.h{fill:#fdb0a0}.i{fill:#c86f5c}.j{fill:#873f30}.k{fill:#a34f41}.l{fill:#9cf}.m{fill:#b6dbff}.n{fill:#fb545c}.o{fill:#e8333c}.p{fill:#61a0e0}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m3.5 19h5.9v70h-5.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m3.5 19l45-18.3 45.1 18.3v4.4h-45.1-45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m48.5 0.7l45.1 18.3v4.4h-22.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m87.7 19h5.9v70h-5.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m2.2 19h92.7c0.8 0 1.5 0.7 1.5 1.5v15.1c0 0.9-0.7 1.5-1.5 1.5h-92.7c-0.9 0-1.5-0.6-1.5-1.5v-15.1c0-0.8 0.6-1.5 1.5-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m94.9 19h-90.7v13.6c0 0.8 0.7 1.5 1.5 1.5h90.7v-13.6c0-0.8-0.7-1.5-1.5-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m35.4 25.7h26.3v4.7h-26.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m14.7 73.9h15.2v15.1h-15.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m20.1 73.9h4.4v4.9h-4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m14.7 58.7h15.2v15.2h-15.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "m20.1 58.7h4.4v4.9h-4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m29.9 43.6h15.1v15.1h-15.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m35.2 43.6h4.5v4.9h-4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m29.9 73.9h15.1v15.1h-15.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "m35.2 73.9h4.5v4.9h-4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "m29.9 58.7h15.1v15.2h-15.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m35.2 58.7h4.5v4.9h-4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m29.9 43.6h1.6v15.1h-1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m29.9 58.7h1.6v15.2h-1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m29.9 73.9h1.6v15.1h-1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m14.7 58.7h1.7v15.2h-1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m14.7 73.9h1.7v15.1h-1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "m89.2 91.8c0.2-5.3 0.3-10.4 0-16-0.3-3.1-1-4.3-2.9-5.4-2-1.2-6-2-8.8-2.8l-0.4-0.1c-1-0.3-2.1-0.1-3 0.7-2.2 1.8-5.3 1.8-7.6 0-0.8-0.8-1.9-1-3-0.7l-0.4 0.1c-2.8 0.8-6.7 1.6-8.7 2.8-2 1.1-2.7 2.3-2.9 5.4-0.3 5.6-0.2 10.7 0 16 0.1 2.6 2.3 4.7 4.9 4.7h27.9c2.6 0 4.8-2.1 4.9-4.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "m70.3 69.6c-1.3 0-2.6-0.5-3.8-1.4-0.8-0.8-1.9-1-3-0.7l-0.4 0.1c-2.8 0.8-6.7 1.6-8.7 2.8-2 1.1-2.7 2.3-2.9 5.4-0.3 5.6-0.2 10.7 0 16 0.1 2.6 2.3 4.7 4.9 4.7h13.9c0 0 0-26.9 0-26.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m70.3 65c-9.6-0.6-12.2-19.7 0-19.7 12.2 0 9.7 19.1 0 19.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m70.3 65c-9.6-0.6-12.2-19.7 0-19.7q0.9 0 1.7 0.1c4.9 4.8 3.7 14.8-1.4 19.6q-0.1 0-0.3 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "m68.7 69.3l-1.5 15 3.1 4.6 3.2-4.6-1.5-15c-1.1 0.3-2.2 0.3-3.3 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "m70.3 88.9l3.2-4.6-1.5-15q-0.8 0.3-1.7 0.3c0 0 0 19.3 0 19.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "m57.5 96.5v-12.8c0-0.7 0.6-1.3 1.3-1.3 0.8 0 1.4 0.6 1.4 1.3v12.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "m80.5 96.5v-12.8c0-0.7 0.6-1.3 1.3-1.3 0.8 0 1.4 0.6 1.4 1.3v12.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg13);
export default __webpack_public_path__ + "static/media/13.4a978e9f21a9a21334a431fca223c522.svg";
export { ForwardRef as ReactComponent };